angular.module('impactx.combibudget').controller('CombiBudgetOverviewListCtrl', [
    'selectedListItems',
    'DownloadService',
    'BudgetImportService',
    CombiBudgetOverviewListCtrl
]);

function CombiBudgetOverviewListCtrl(selectedListItems, DownloadService, BudgetImportService) {

    var buttonDefinition = [
        {
            label: "ctuList",
            linkFunction: getCTUListLink,
            type: 'link',
            condition: canCTUList,
            process: 'ViewCombiBudgets'
        },
        {
            label: "cttList",
            linkFunction: getCTTListLink,
            type: 'link',
            condition: canCTTList,
            process: 'ViewCombiBudgets'
        },
        {
            label: "import",
            action: importBudget,
            condition: selectedListItems.isNoSelection,
            process: 'ImportCombiBudgets'
        },
        {
            label: "export",
            action: exportBudget,
            condition: selectedListItems.isNoSelection,
            process: 'ExportCombiBudgets'
        }
    ];

    function canCTUList() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().ctuId > 0;
    };

    function canCTTList() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().cttId > 0;
    };

    function getCTUListLink() {
        return "combibudget/ctu/" + selectedListItems.getFirstSelectedItem().ctuId;
    };

    function getCTTListLink() {
        return "combibudget/ctt/" + selectedListItems.getFirstSelectedItem().cttId;
    };

    function importBudget(event, trns) {
        BudgetImportService.showUploadDialog(event, trns, '/combibudget/import');
    };

    function exportBudget() {
        DownloadService.openDownloadPost('/combibudget/export', {});
    };

    this.meta = {
        rowTemplate: 'modules/combibudget/templates/overviewlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/combibudget/overview',
        id: "combibudgetoverview",
        excelExport: true,
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    };
}